import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ROLE_HOME = {
  superadmin:   '/superadmin',
  admin:        '/admin',
  clerk:        '/clerk',
  collegeadmin: '/collegeadmin',
};

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user)   return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to={ROLE_HOME[user.role] || '/login'} replace />;
  return children;
};

export default ProtectedRoute;
